var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#01745F",
    fillRule: "evenodd",
    d: "M5 0a5 5 0 1 1 0 10A5 5 0 0 1 5 0zm1.571 2.643L5 4.214 3.429 2.643l-.786.786L4.214 5 2.643 6.571l.786.786L5 5.786l1.571 1.571.786-.786L5.786 5l1.571-1.571-.786-.786z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRound);
export default __webpack_public_path__ + "static/media/close-round.f398c9d3391280851c34019537055d52.svg";
export { ForwardRef as ReactComponent };